const WebsiteRecommendationEntity = (backClient) => ({
  index: async () => {
    const { data } = await backClient.get(`/api/recommendations/websites`)
    return data
  },
})
export default WebsiteRecommendationEntity
